import { useAuthStore } from "@wlink/commons/auth";
import type { RouteRecordRaw } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/LoginView.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/healthcheck/get",
    name: "HealthCheck",
    component: () => import("../views/HealthCheck/Get.vue"),
  },
  {
    path: "/",
    name: "Layout",
    component: () => import("../views/LayoutView.vue"),
    redirect: "/apply-tenant",
    meta: { requiresAuth: true },
    children: [
      // {
      //   path: "tenants",
      //   name: "Tenants",
      //   component: () => import("../views/TenantsView/index.vue"),
      //   meta: {
      //     title: "租户管理",
      //     requiresAuth: true,
      //   },
      // },
      {
        path: "apply-tenant",
        name: "ApplyTenant",
        component: () => import("../views/ApplyTenantView/index.vue"),
        meta: {
          title: "申请租户列表",
          requiresAuth: true,
        },
      },
      {
        path: "tenants/trial",
        name: "TenantsTrial",
        component: () => import("../views/TenantsView/TrialView.vue"),
        meta: {
          title: "试用租户管理",
          requiresAuth: true,
        },
      },
      {
        path: "tenants/paid",
        name: "TenantsPaid",
        component: () => import("../views/TenantsView/PaidView.vue"),
        meta: {
          title: "付费租户管理",
          requiresAuth: true,
        },
      },
      {
        path: "tenants/detail",
        name: "TenantsDetail",
        component: () => import("../views/TenantsView/detail.vue"),
        meta: {
          title: "租户信息",
          titleKey: "租户信息",
          requiresAuth: true,
          showBackButton: true,
        },
      },
      {
        path: "payment-config",
        name: "PaymentConfig",
        component: () => import("../views/PaymentConfigView/index.vue"),
        meta: {
          title: "支付配置",
          requiresAuth: true,
        },
      },
      // 公共服务
      {
        path: "common-services/verification",
        name: "VerificationModule",
        component: () =>
          import("../views/CommonServicesView/VerificationModuleView.vue"),
        meta: { title: "验证模块", requiresAuth: true },
      },
      {
        path: "common-services/email-providers",
        name: "EmailProviders",
        component: () =>
          import("../views/CommonServicesView/EmailProvidersView.vue"),
        meta: { title: "邮件服务商", requiresAuth: true },
      },
      {
        path: "common-services/electronic-verification",
        name: "ElectronicVerification",
        component: () =>
          import("../views/CommonServicesView/ElectronicVerificationView.vue"),
        meta: { title: "电子验证服务商", requiresAuth: true },
      },
      {
        path: "common-services/exchange-rate",
        name: "ExchangeRate",
        component: () =>
          import("../views/CommonServicesView/ExchangeRateView.vue"),
        meta: { title: "汇率服务商", requiresAuth: true },
      },
      {
        path: "email-module",
        name: "EmailModule",
        component: () => import("../views/email/EmailSettingsView.vue"),
        meta: {
          title: "邮件模块",
          titleKey: "邮件模块",
          requiresAuth: true,
        },
      },
      {
        path: "role-permission",
        name: "RolePermission",
        component: () => import("../views/RolePermissionView.vue"),
        meta: { title: "角色权限", requiresAuth: true },
      },
      {
        path: "api-key",
        name: "ApiKeyView",
        component: () => import("../views/ApiKeyView/index.vue"),
        meta: {
          title: "Api Key 管理",
          requiresAuth: true,
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // 如果认证状态还没初始化，等待
  if (!authStore.isAuthReady) {
    const waitReady = () =>
      new Promise((resolve) => {
        const timer = setInterval(() => {
          if (authStore.isAuthReady) {
            clearInterval(timer);
            resolve(true);
          }
        }, 10);
      });
    await waitReady();
  }

  // 检查是否为重置密码场景
  const isPasswordReset =
    to.path === "/login" &&
    to.query.action === "reset_password" &&
    to.query.token;

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next("/login");
  } else if (
    to.path === "/login" &&
    authStore.isAuthenticated &&
    !isPasswordReset
  ) {
    // 如果是重置密码场景，即使已认证也允许访问登录页面
    next("/");
  } else {
    next();
  }
});

export default router;
